import { render, staticRenderFns } from "./ClusterRoleBindingPropertyPanel.vue?vue&type=template&id=818f6ed0&"
import script from "./ClusterRoleBindingPropertyPanel.vue?vue&type=script&lang=js&"
export * from "./ClusterRoleBindingPropertyPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VIcon,VListItemTitle,VSelect,VTextField})
